



















helpers = require('../../../helpers.coffee')

view_model = {
  methods:
    hide: ->
      jQuery('#quota_exceeded').modal 'hide'

    show: ->
      jQuery('#quota_exceeded').modal 'show'

    removeQuotaExceeded: ->
      EventsBus.$emit 'send-email-quota-exceeded'
      @hide()

  created: ->
    EventsBus.$on 'quota-exceeded-modal', @show

  beforeDestroy: ->
    EventsBus.$off 'quota-exceeded-modal', @show

}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/compose/quota_exceeded.vue